import { render } from "./UserSection.vue?vue&type=template&id=b81d8a72&scoped=true"
import script from "./UserSection.vue?vue&type=script&lang=js"
export * from "./UserSection.vue?vue&type=script&lang=js"

import "./UserSection.vue?vue&type=style&index=0&id=b81d8a72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81d8a72"]])

export default __exports__